import DefaultLayout from "../layouts/DefaultLayout";
import { useNavigation } from "@react-navigation/native";
import CustomText from "../components/common/general/CustomText/CustomText.js";
import CustomButton from "../components/common/general/CustomButton/CustomButton.js";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";
import { View, StyleSheet } from "react-native";

function AdminView() {
  const navigation = useNavigation();

  const handleAdminPress = () => {
    navigation.navigate("Tenant Dashboard");
  };

  const handleOAuthPress = () => {
    navigation.navigate("OAuth Client Dashboard");
  };

  const handleCreateTenantPress = () => {
    navigation.navigate("Create Tenant");
  };

  return (
    <DefaultLayout pageHasChat={false}>
      <CustomText
        role="header"
        text="Dashboard"
        size="l"
        textType="display"
        weight="ultraBold"
        useTranslationText={false}
      />
      <CustomSpacing size="xxl" />
      <CustomButton
        text="Tenant Dashboard"
        onPress={handleAdminPress}
        useTranslationText={false}
        styleType="primary"
        size="m"
        style={styles.button}
      />
      <CustomSpacing size="xxl" />
      <CustomButton
        text="OAuth Clients"
        onPress={handleOAuthPress}
        useTranslationText={false}
        styleType="primary"
        size="m"
        style={styles.button}
      />
      <CustomSpacing size="xxl" />
      <CustomButton
        text="Create New Tenant"
        onPress={handleCreateTenantPress}
        useTranslationText={false}
        styleType="primary"
        size="m"
        style={styles.button}
      />
    </DefaultLayout>
  );
}

const styles = StyleSheet.create({
  button: {
    width: "100%",
    justifyContent: "center",
    maxWidth: 300,
  },
});

export default AdminView;
